import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useModal } from '../../hooks/useModal';

const BenefitsSection: React.FC = () => {
  const { openUserTypeModal } = useModal();

  return (
    <Container className="d-flex" id="benefits">
      <div className="mx-auto justify-content-center align-items-center align-content-center">
        <h2 className="text-center" id="benefitsH2Desktop">
          Everything you need to pull off an<br />
          <span className="text-whatshot">unforgettable event</span> in one place.
        </h2>
        <h2 className="text-center d-none" id="benefitsH2Mobile">
          Everything you need to<br />
          pull off an
          <span className="text-whatshot">unforgettable</span> <span className="text-whatshot"> event</span> in one place.
        </h2>

        <Row className="mb90">
          <Col lg={6} xs={12}>
            <img src="/assets/images/Frame 4.png" className="img-fluid d-block" alt="Event Planning" />
          </Col>
          <Col lg={6} xs={12} className="my-auto pl34">
            <h3 className="display-5 fw-bold lh-sm" id="effortD">Effortless Event Planning</h3>
            <h3 className="d-none" id="effortM">Effortless Event Planning</h3>
            <p className="fs-6">
              Organize a flawless event in one easy-to-use<br className="brLine" />
              platform.
            </p>
            <ul className="fs-5">
              <li>Connect with top-rated professionals</li>
              <li>Track your spending and budgets</li>
              <li>Collaborate and pay. Safe & secure.</li>
            </ul>
            <button className="main-button" onClick={openUserTypeModal}>
              Join the Waitlist
            </button>
          </Col>
        </Row>

        <Row className="flex-lg-row flex-column-reverse mb90">
          <Col lg={6} xs={12} className="my-auto">
            <h3 className="display-5 fw-bold lh-sm ps-2" id="affordM">
              Find Affordable<br />
              Professionals.<br />
              Stress-free.
            </h3>
            <ul>
              <li>Work with vetted vendors only.</li>
              <li>Choose right with reviews and ratings.</li>
              <li>Get proposals and pricing you can afford.</li>
            </ul>
            <button className="main-button" onClick={openUserTypeModal}>
              Join the Waitlist
            </button>
          </Col>
          <Col lg={6} xs={12}>
            <img src="/assets/images/image 20.png" className="img-fluid d-block" alt="Professionals" />
          </Col>
        </Row>

        <Row className="mb-lg-0">
          <Col lg={6} xs={12} className="text-end">
            <img src="/assets/images/Frame 4 (1).png" className="img-fluid d-block" alt="Location Services" />
          </Col>
          <Col lg={6} xs={12} className="text-start my-auto pl34">
            <p id="workWithM">
              Work with anyone,<br />
              anywhere. Or find<br />
              someone nearby.
            </p>
            <p>
              Remote professionals are available.
            </p>
            <p>
              But we know your events need onsite help.<br />
              Find service providers near your location.
            </p>
            <button className="main-button" onClick={openUserTypeModal}>
              Join the Waitlist
            </button>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default BenefitsSection;
